/* eslint-disable react/prop-types */
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CopyFilledIcon } from '../../../../../assets/svgs/icons'
import styles from './styles.module.css'

export const EditLegendField = ({
  legend,
  setLegend,
  onGenerateSubtitle,
  onCopyLegend
}) => {
  const [gptInput, setGptInput] = useState('')
  const {t} = useTranslation()

  return (
    <div
      style={{
        display: 'flex',
        border: '1px solid #D9D9D9',
        borderRadius: 20,
        position:'relative',
        padding: 20,
      }}
    >     
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 20,
          cursor: 'default',

          flex: 1,
        }}
      >
        <div
          className={styles.form_container_input}
          style={{
            cursor: 'default',
          }}
        >
          <div style={{
            display:'flex',
            flex:1,
            justifyContent:'space-between'
          }}>

            <label
              style={{
                fontSize: 14,
                color: '#686868',
                fontWeight: 500,
                fontFamily: 'Poppins',
              }}
            >
              {t('new_publication_page_ia_step_fourth_legend')}
            </label>
            <button
              className={styles.copy_button}
              onClick={onCopyLegend}
            >
              <CopyFilledIcon size={20} color={'#FF8B00'}/>
              <span>{t('new_publication_page_ia_step_fourth_copy_legend')}</span>
            </button>
          </div>

          <textarea
            readOnly={false}
            name=""
            id=""
            cols="30"
            rows="10"
            value={legend || ''}
            style={{
              width: '100%',
              height:'fit-content',
              maxHeight:195,
              borderRadius: 6,
              border: '1px solid #ededed',
              backgroundColor: '#E0E0E0',
              padding: '10px',
              color: '#190027',
              resize: 'none',
              outline: 'none',
              fontFamily: 'Poppins',
              fontWeight:300,
              fontSize: 14,
            }}
            onChange={(e) => setLegend(e.target.value)}
            placeholder={t('stepMyPublication.legendPlaceholder')}
          />

          <div
            style={{
              display: 'flex',
              gap: 20,
            }}
          >
            <input
              value={gptInput}
              onChange={(e) => setGptInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onGenerateSubtitle(gptInput)
                }
              }}
              type="text"
              placeholder={t('new_publication_page_ia_step_fourth_prompt_legend')}
              style={{
                width: '100%',
                borderRadius: 10,
                border: '1px solid #ededed',
                backgroundColor: '#ededed',
                padding:15,
                fontSize:14,
                fontFamily: 'Poppins',
                color: '#190027',
              }}
            />
            <button
              onClick={()=>onGenerateSubtitle(gptInput)}
              style={{
                borderRadius:10,
                padding:'15px 20px',
                height:'min-content',
                backgroundColor: '#6A0098',
              }}
            >
             
              <p style={{
                color: '#fff',
                fontSize: 14,
                margin:0,
                fontFamily: 'Poppins',
                textWrap:'nowrap'
              }}> 
                {t('new_publication_page_ia_step_fourth_button_generate')}
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}